module.exports = __webpack_public_path__ + "img/help_circle.59c8f0e9.svg";